import { Component, OnInit, Injector, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MediaObserver } from '@angular/flex-layout';
import { catchError, map, of, Subscription } from 'rxjs';
import { MenuService } from '../../core/service/menu.service';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { SeguridadService } from '../../core/service/seguridad/seguridad.service';
import { Alerts } from 'src/app/utils/alert';
import { MenuResponseModel } from 'src/app/core/model/api-suc';
import { MenuModel } from 'src/app/core/model/menu.model';
import { TypeAlert } from 'src/app/shared/constants/enums.interface';
import { EnvconfigService } from 'src/app/core/service/envconfig.service';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { RetroalimentacionComponent } from '../retroalimentacion/retroalimentacion.component';
import { MatDialogRef } from '@angular/material/dialog';
import { GeneralService } from 'src/app/core/service/general/general.service';
import { NovedadesNoticiasActualesComponent } from '../novedades-noticias-actuales/novedades-noticias-actuales.component';
import { NovedadNoticiasService } from 'src/app/core/service/general/novedad-noticias.service';
import { ListaNovedadesNoticias } from 'src/app/core/model/general/novedades-noticias/ListaNovedadesNoticias';
import { obtenerMensajeError } from 'src/app/core/common/get-message-error';
import swal from 'sweetalert2';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
  standalone: false
})
export class LayoutComponent implements OnInit {

  private noticiasService = inject(NovedadNoticiasService);

  public menuItems: MenuResponseModel | undefined;
  deviceXs!: boolean;
  mediaSub!: Subscription;
  public mode: any;
  public username: string = '';
  public rol: string = '';
  public strRol: string = '';
  tipoRolUsuario: string = "";
  public AppTitle: string = "";
  public lstMenu: MenuModel[] | undefined;
  public lstSubMenu: any[] | undefined;
  public version: string = "";
  openedPanel: any = null;
  MenuNombre: string = "";
  openedSubPanel: any = null;
  blFaltaComentario: boolean = true;

  private isDragging = false; // Bandera para identificar si se está arrastrando
  private offsetX = 0;
  private offsetY = 0;

  positionX: number = 10;
  positionY: number = 10;
  dragging: boolean = false;

  dragStartX: number = 0;
  dragStartY: number = 0;

  isDragged: boolean = false;

  constructor(
    private routers: Router,
    public injector: Injector,
    public mediaObserver: MediaObserver,
    public menuService: MenuService,
    public seguridadService: SeguridadService,
    private matIconRegistry: MatIconRegistry,
    private alerts: Alerts,
    private domSanitizer: DomSanitizer,
    private breakpointObserver: BreakpointObserver,
    private environment: EnvconfigService,
    private location: Location,
    public dialog: MatDialog,
    private generalService: GeneralService) {
    this.matIconRegistry.addSvgIcon("icon-tools", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/icon-tools.svg"));
    this.matIconRegistry.addSvgIcon("icon-pencil", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/icon-pencil.svg"));
    this.matIconRegistry.addSvgIcon("icon-sync", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/icon-sync.svg"));
    // cualquier SVG PERSONALIZADO DEBE IR CON DOBLE GUION
    this.matIconRegistry.addSvgIcon("money--hand", this.domSanitizer.bypassSecurityTrustResourceUrl("assets/icons/icons8-moneda-32.svg"));
    if (localStorage.getItem(environment.get("LISTA_MENU")) != null) {
      this.menuItems = menuService.getMenuSistema();
      this.lstMenu = this.menuItems.lstMenu;
      this.lstSubMenu = this.menuItems.lstSubMenu;
      this.lstSubMenu = this.agregarTieneHijos(this.lstSubMenu);


      this.username = localStorage.getItem(environment.get("USERNAME"))!;
      this.rol = localStorage.getItem(environment.get("NOMBRE_ROL_USUARIO"))!;
      this.AppTitle = environment.get("APPTITLE").toString();
      this.version = "4.0.0"

      this.strRol = this.seguridadService.getUsuarioRol.trim().toUpperCase();
    }
  }

  public isScreenSmall: boolean = false;
  private activeMediaQuery = '';
  private intervalo: any;
  private dialogRef: MatDialogRef<RetroalimentacionComponent> | null = null;
  private dialogRefNovedades: MatDialogRef<NovedadesNoticiasActualesComponent> | null = null;
  private subscriptionsArray: Subscription[] = [];
  private SolicitudSubscription!: Subscription;

  ngOnInit(): void {

    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small])
      .subscribe((state: BreakpointState) => {
        this.isScreenSmall = state.matches;
      })

    this.mediaSub = this.mediaObserver.asObservable().subscribe((change) => {
      change.forEach((item) => {
        this.activeMediaQuery = item
          ? `'${item.mqAlias}' = (${item.mediaQuery})`
          : '';
        this.mode = item.mqAlias === "xs" ? "over" : "side";
        this.deviceXs = item.mqAlias === "xs";
      });
    })
    this.ObtenerCalificacionUsuario();

    this.mostrarNoticiasActivas();

    setTimeout(() => {
      this.ejecutarAccion();
    }, 120000);

    /* if (this.strRol === "UIFI") {
      this.abrirNovedadesNoticiasActuales();
    }

    if (this.strRol === "UOPERAD") {
      this.abrirNovedadesNoticiasActuales();
    } */
  }

  cerrarSession() {
    this.alerts.Notificacion(TypeAlert.Confirm, "¿Estás seguro de volver a tus productos?<br><br><b>Tienes un producto sin guardar</b>", "Confirmación")
      .then((result) => {
        if (result.isConfirmed) {
          this.alerts.Notificacion(TypeAlert.Info, "Sesión cerrada del Proyecto Base.<br>Para iniciar session nuevamente, puede acceder desde el Menu Principal", "Información")
          this.seguridadService.cerrarSesion();
        }
      });

  }

  agregarTieneHijos(menuItems) {
    // Creamos un objeto para almacenar los ids de los elementos padres
    const padres = {};

    // Iteramos sobre el arreglo para identificar los elementos padres
    menuItems.forEach(item => {
      return item.tieneHijos = false;
    });

    // Iteramos nuevamente para agregar el valor "tieneHijos" a los elementos
    menuItems.forEach(item => {
      // @ts-ignore
      menuItems.forEach(item2 => {
        if (item.id == item2.idMenuPadre) {
          return item.tieneHijos = true;
        }
      })
    });

    return menuItems;
  }

  onPanelOpen(menu: any) {
    this.routers.navigate(['/home/inicio'], {
      queryParams: {
        tituloMenuPadre: menu.nombre
      }
    })

    if (this.openedPanel && this.openedPanel !== menu) {
      this.openedPanel.expanded = false;
    }
    this.openedPanel = menu;

  }

  onPanelOpenSubmenu(menu: any) {
    this.routers.navigate(['/home/inicio'], {
      queryParams: {
        tituloMenuPadre: menu.nombre
      }
    })

    if (this.openedSubPanel && this.openedSubPanel !== menu) {
      this.openedSubPanel.expanded = false;
    }
    this.openedSubPanel = menu;

  }

  onPanelClose(menu: any) {
    if (this.openedPanel == menu)
      this.routers.navigate(['/home/inicio'])
  }

  myfunction() { }

  /*AbrirCalificador(){
      if (!this.estaModalAbierto()) {
         this.dialogRef = this.dialog.open(RetroalimentacionComponent, {
        width: '700px',
        height:'350px',
        panelClass: 'custom-overlay-modal'
         });

         this.dialogRef.afterOpened().subscribe(() => {
        const overlay = document.getElementsByClassName('cdk-overlay-pane');
        if (overlay.length > 0) {
            (overlay[overlay.length - 1] as HTMLElement).style.zIndex = '5000'; // Asegúrate que sea mayor que otros
        }
         });

         // Opcional: limpiar la referencia cuando el modal se cierre
         this.dialogRef.afterClosed().subscribe((result: boolean) => {
        if (result !== undefined) {
          this.blFaltaComentario = result;
        }
        this.dialogRef = null;
         });
      }
  }*/

  ejecutarAccion(): void {
    if (this.blFaltaComentario) {
      this.AbrirCalificador();
    }
  }

  ngOnDestroy(): void {
    if (this.SolicitudSubscription) {
      this.SolicitudSubscription.unsubscribe();
    }

    this.subscriptionsArray.forEach(subscription => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
    // Limpia el intervalo al destruir el componente
    if (this.intervalo) {
      clearInterval(this.intervalo);
    }


  }

  estaModalAbierto(): boolean {
    // Verifica si el modal está abierto comprobando la referencia
    return this.dialogRef !== null;
  }

  estaModalNovedadesAbierto(): boolean {
    // Verifica si el modal está abierto comprobando la referencia
    return this.dialogRefNovedades !== null;
  }

  ObtenerCalificacionUsuario() {

    this.SolicitudSubscription = this.generalService.ObtenerCalificacionUsuario(this.seguridadService.getCodigoUsuario ?? '').pipe().subscribe({
      next: (response) => {
        if (response.data != null) {
          this.blFaltaComentario = response.data;
        }
      },
      error: (error) => {
        this.alerts.Notificacion(TypeAlert.Error, "Ocurrió un error al cargar comentarios usuario", "Error");
      },
      complete: () => {

      }
    });

    this.subscriptionsArray.push(this.SolicitudSubscription);

  }


  // Iniciar arrastre
  /*startDrag(event: MouseEvent): void {
    this.dragging = true;
    this.dragStartX = event.clientX;
    this.dragStartY = event.clientY;
    event.preventDefault();


  }*/

  /*stopDrag(event: MouseEvent): void {

    if (this.dragging) {
      const moveX = Math.abs(event.clientX - this.dragStartX);
      const moveY = Math.abs(event.clientY - this.dragStartY);

      // Si hubo un movimiento considerable, prevenir clic
      if (moveX > 10|| moveY > 10) {
        event.stopPropagation();
      }

    }

    this.dragging = false;



  }*/

  // Manejar movimiento
  /*drag(event: MouseEvent): void {
    if (this.dragging) {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;


      this.positionX = Math.max(0, windowWidth - event.clientX - 100);
      this.positionY = Math.max(0, windowHeight - event.clientY - 100);
    }
  }*/

  startDrag(event: MouseEvent): void {
    this.dragging = true;
    this.isDragged = false; // Resetear la bandera al comenzar a arrastrar
    this.dragStartX = event.clientX;
    this.dragStartY = event.clientY;
    event.preventDefault();
  }

  drag(event: MouseEvent): void {
    if (this.dragging) {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      // Actualizar la posición del ícono
      this.positionX = Math.max(0, windowWidth - event.clientX - 100);
      this.positionY = Math.max(0, windowHeight - event.clientY - 100);

      // Si el ícono se movió más de un umbral, marcarlo como arrastrado
      const moveX = Math.abs(event.clientX - this.dragStartX);
      const moveY = Math.abs(event.clientY - this.dragStartY);
      if (moveX > 10 || moveY > 10) {
        this.isDragged = true;
      }
    }
  }

  stopDrag(event: MouseEvent): void {
    if (this.dragging) {
      const moveX = Math.abs(event.clientX - this.dragStartX);
      const moveY = Math.abs(event.clientY - this.dragStartY);

      // Si hubo un movimiento considerable, prevenir clic
      if (moveX > 10 || moveY > 10) {
        event.stopPropagation();
      }

      this.dragging = false;
    }
  }

  AbrirCalificador() {
    if (!this.isDragged) {
      if (!this.estaModalAbierto()) {
        this.dialogRef = this.dialog.open(RetroalimentacionComponent, {
          width: '700px',
          height: '350px',
          panelClass: 'custom-overlay-modal'
        });

        this.dialogRef.afterOpened().subscribe(() => {
          const overlay = document.getElementsByClassName('cdk-overlay-pane');
          if (overlay.length > 0) {
            (overlay[overlay.length - 1] as HTMLElement).style.zIndex = '5000'; // Asegúrate que sea mayor que otros
          }
        });

        this.dialogRef.afterClosed().subscribe((result: boolean) => {
          if (result !== undefined) {
            this.blFaltaComentario = result;
          }
          this.dialogRef = null;
        });
      }
    }

  }

  mostrarNoticiasActivas() {

    if (!this.isDragged) {

      this.noticiasService.getNovedadNoticiaActivas()
        .pipe(
          map((respuesta: any) => {

            if (!respuesta.success) throw new Error(respuesta.message);
            return respuesta.data as ListaNovedadesNoticias[];

          }),
          catchError((error) => {

            this.alerts.Notificacion(TypeAlert.Error, obtenerMensajeError(error), "Error");
            return of([]);

          })
        )
        .subscribe({
          next: (noticiasActivas: ListaNovedadesNoticias[]) => {
            if (noticiasActivas.length > 0) {

              const htmlLista = this.generarHtmlParaNoticias(noticiasActivas);

              swal.mixin({
                icon: 'info',
                title: "¡NOTICIAS IMPORTANTES!",
                html: htmlLista,
                confirmButtonText: 'ACEPTAR'
              }).fire();

            }
          },
          error: (err) => this.alerts.Notificacion(TypeAlert.Error, obtenerMensajeError(err), "Error")
        });

    }

  }

  private generarHtmlParaNoticias(noticiasActivas: ListaNovedadesNoticias[]) {

    return `<div class="text-justify">
                <ul class="ps-2 pe-1 text-primary" style="list-style-type: disc;">
                  <style>
                    ul li::marker {
                      color: #004f91;
                      font-size: 28px;                        
                    }
                    ul li {
                      color: black;
                    }
                  </style>
                  ${noticiasActivas.map(m => `<li class="mb-1 text-with-lines">${m.vcTexto}</li>`).join("")}
                </ul>
            </div>`;

  }

}
